import { inject, Service } from '@angular/core';
import { Router } from '@angular/router';

/** Le motif décrit le contrôle réellement effectué, sans déduire un rôle manquant d’un simple 403. */
export type RefusAccesPage =
  | {
      motif: 'administration' | 'sans-installation' | 'interdit' | 'introuvable' | 'indisponible';
    }
  | { motif: 'serveur'; message?: string; details?: string | string[] }
  | {
      motif: 'installation';
      installationId: number;
      installationNom?: string;
      source?: 'liste-tickets';
    };

/** Transmet le motif à la page de refus, uniquement pour la navigation qui l’a produit. */
@Service()
export class AccesPages {
  private readonly router = inject(Router);
  private dernierRefus: { navigationId: number; contexte: RefusAccesPage } | null = null;

  /** false fait choisir au routeur la page de refus au même chemin, sans redirection. */
  refuser(navigationId: number | undefined, contexte: RefusAccesPage): false {
    if (navigationId !== undefined && this.router.currentNavigation()?.id === navigationId) {
      this.dernierRefus = { navigationId, contexte };
    }
    return false;
  }

  /** Une réponse tardive ou une ancienne navigation ne doit pas imposer son message. */
  refusCourant(): RefusAccesPage {
    const refus = this.dernierRefus;
    return refus && refus.navigationId === this.router.currentNavigation()?.id
      ? refus.contexte
      : { motif: 'interdit' };
  }
}
